import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import MonthlyListenersChart from "./Charts/MonthlyListenerChart";
import TopListenersChart from "./Charts/TopListener";
import { Icon } from "@iconify/react/dist/iconify.js";

const StatsRap = styled.div`
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #bac0d499;
  padding: 50px;
  @media (max-width: 1400px) {
    padding: 20px;
  }
  @media (max-width: 1330px) {
    padding: 10px;
  }

  .events-sub-1 h4 {
    color: #060b13;
    font-size: 20px;
    font-weight: 600;
  }
  .events-sub-1 p {
    color: #363d4f;
    font-size: 15px;
    font-weight: 400;
  }
  .events-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .events-2 {
    border: 0.7px solid #bac0d499;
    border-radius: 20px;
    padding: 24px 32px;
    margin-top: 30px;
  }
  .search-div-input input {
    border: 0.64px solid #bac0d4b2;
    padding-left: 20px;
    width: 268px;
    height: 40px;
    border-radius: 100px;
  }
  .filter-div p {
    color: #344054;
    font-weight: 400;
    font-size: 14px;
  }
  .filter-div {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.64px solid #bac0d4b2;
    width: 92px;
    height: 40px;
    gap: 10px;
    cursor: pointer;
    border-radius: 100px;
  }
  .event-sub-2 {
    display: flex;
    gap: 20px;
  }
  .link-container {
    display: flex;
    gap: 15px;
  }
  .link {
    text-decoration: none;
    color: #818893;
    font-size: 14px;
    font-weight: 500;
    padding-bottom: 10px;
  }
  .link.active {
    color: #060b13;
    border-bottom: 3px solid #000000;
  }
  .link-sub-event {
    display: flex;
    justify-content: space-between;
  }
  .sub-dash-2 {
    width: 248px;
    border-radius: 12px;
    border: 1px solid #bac0d499;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    justify-content: center;
    padding: 20px;
  }
  .sub-dash-2 p {
    color: #818893;
    font-size: 14px;
    margin: 0px;
    font-weight: 400;
  }
  .sub-dash-2 h4 {
    color: #060b13;
    font-size: 30px;
    font-weight: 700;
    display: flex;
    margin: 0px;
    width: 100%;
    align-items: center;
    justify-content: space-between !important;
  }
  .sub-dash-2 span {
    background: #ecfdf3;
    width: 66px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #027a48;
    font-size: 12px;
    font-weight: 400;
    border-radius: 16px;
  }
  .dash-2 {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 30px;
  }
  .sub-dash-3-1 {
    border: 1px solid #bac0d499;
    border-radius: 20px;
    width: 70%;
    padding: 20px;
  }
  .sub-dash-3-2 {
    width: 30%;
    padding: 20px;
    border: 1px solid #bac0d499;
    border-radius: 20px;
  }
  .dash-3 {
    display: flex;
    gap: 15px;
    margin-top: 30px;
  }
  table {
    border: none;
    border-radius: 8px;
  }
  th {
    border: none;
  }
  td {
    border: none;
    border-top: 1px solid #bac0d499;
  }
  td {
    height: 72px;
    font-size: 14px;
    font-weight: 500;
  }
  th {
    background: #f9fafb;
    height: 44px;
    text-align: start;
    padding-left: 10px;
    color: #475467;
    font-size: 12px;
    font-weight: 500;
  }
  .username-pic img {
    width: 40px;
    border-radius: 50%;
    height: 40px;
  }
  .username-pic {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .filter-btn {
    padding: 5px;
    display: flex;
    gap: 10px;
    border: 1px solid #bac0d4b2;
    border-radius: 6px;
    width: 235px;
    margin: 30px 0px;
  }
  .filter-btn-button {
    border: none;
    color: #818893;
    font-size: 14px;
    font-weight: 500;
    background: #ffffff;
    width: 235px;
  }
  .filter-btn-button.active {
    background: #10182814;
    height: 34px;
    border-radius: 5px;
    width: 110px;
    color: #060b13;
    width: 235px;
  }
  .all-user-inner-div {
    border: 1px solid #bac0d499;
    border-radius: 12px;
    padding: 24px;
  }
  .top-listen-head,
  .month-listen-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .new-table-scroll {
    width: 100% !important;
    overflow-x: auto;
  }

  /* For WebKit Browsers (Chrome, Edge, Safari) */
  .new-table-scroll::-webkit-scrollbar {
    height: 3px; /* Set scrollbar width */
  }

  .new-table-scroll::-webkit-scrollbar-thumb {
    background: #888; /* Scrollbar thumb color */
    border-radius: 4px; /* Optional for rounded scrollbar */
  }

  .new-table-scroll::-webkit-scrollbar-thumb:hover {
    background: #555; /* Thumb hover color */
  }

  .new-table-scroll::-webkit-scrollbar-track {
    background: #f1f1f1; /* Scrollbar track color */
  }

  /* Hide Up and Down Arrows in Scrollbar */
  .new-table-scroll::-webkit-scrollbar-button {
    display: none; /* Hides the arrows */
  }
  .table-div-con {
    min-width: 600px;
  }

  @media (max-width: 992px) {
    .dash-3 {
      flex-wrap: wrap;
    }
    .sub-dash-3-1 {
      width: 90vw;
    }
    .sub-dash-3-2 {
      width: 50%;
    }
  }
  @media (max-width: 578px) {
    .sub-dash-3-2 {
      width: 90vw;
    }
  }
  @media (max-width: 500px) {
    .events-2 {
      padding: 20px 10px;
    }
  }
`;

const Stats = () => {
  const users = [
    {
      id: 1,
      pic: "/images/user-1.png",
      name: "Olivia Rhye",
      email: "olivia@plugrl.com",
      status: "Unblocked",
    },
    {
      id: 2,
      pic: "/images/user-2.png",
      name: "Phoenix Baker",
      email: "phoenix@plugrl.com",
      status: "Unblocked",
    },
    {
      id: 3,
      pic: "/images/user-3.png",
      name: "Lana Steiner",
      email: "lana@plugrl.com",
      status: "Unblocked",
    },
    {
      id: 4,
      pic: "/images/user-4.png",
      name: "Demi Wilkinson",
      email: "demi@plugrl.com",
      status: "Unblocked",
    },
    {
      id: 5,
      pic: "/images/user-2.png",
      name: "Candice Wu",
      email: "candice@plugrl.com",
      status: "Unblocked",
    },
    {
      id: 6,
      pic: "/images/user-1.png",
      name: "Olivia Rhye",
      email: "olivia@plugrl.com",
      status: "Blocked",
    },
    {
      id: 7,
      pic: "/images/user-2.png",
      name: "Phoenix Baker",
      email: "phoenix@plugrl.com",
      status: "Blocked",
    },
    {
      id: 8,
      pic: "/images/user-3.png",
      name: "Lana Steiner",
      email: "lana@plugrl.com",
      status: "Blocked",
    },
    {
      id: 9,
      pic: "/images/user-4.png",
      name: "Demi Wilkinson",
      email: "demi@plugrl.com",
      status: "Blocked",
    },
    {
      id: 10,
      pic: "/images/user-2.png",
      name: "Candice Wu",
      email: "candice@plugrl.com",
      status: "Blocked",
    },
  ];

  const [filter, setFilter] = useState("Followers"); // Default view is "Followers"

  // Toggle the status of a user
  const toggleStatus = (id) => {
    const index = users.findIndex((user) => user.id === id);
    if (index !== -1) {
      users[index].status =
        users[index].status === "Blocked" ? "Unblocked" : "Blocked";
    }
    setFilter("Followers"); // Trigger re-render and reset to "Followers"
  };

  // Filter users based on the selected filter
  const filteredUsers = users.filter((user) => {
    if (filter === "Blocked") return user.status === "Blocked";
    return user.status === "Unblocked"; // Default to showing "Followers"
  });

  const [activeLink, setActiveLink] = useState("overview");
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };
  return (
    <StatsRap>
      <div className="events-1">
        <div className="events-sub-1">
          <h4>Stats</h4>
          <p>Analyze the number of plays and more</p>
        </div>
      </div>
      <div className="events-2">
        <div className="link-sub-event">
          <div className="link-container">
            <Link
              className={`link ${activeLink === "overview" ? "active" : ""}`}
              onClick={() => handleLinkClick("overview")}
            >
              Overview
            </Link>
            <Link
              className={`link ${activeLink === "users" ? "active" : ""}`}
              onClick={() => handleLinkClick("users")}
            >
              Users
            </Link>
          </div>
          <div className="event-sub-2">
            <div className="filter-div">
              <img src="/images/filter-lines.svg" alt="" />

              <p>Filter</p>
            </div>
          </div>
        </div>
        <div>
          {activeLink === "overview" && (
            <>
              <div>
                <div className="dash-2">
                  <div className="sub-dash-2">
                    <p>Total Listeners</p>
                    <h4>1500K</h4>
                  </div>
                  <div className="sub-dash-2">
                    <p>Total Streams</p>
                    <h4>
                      10.05K{" "}
                      <span>
                        <Icon
                          icon="formkit:arrowup"
                          width="12"
                          height="12"
                          style={{ color: "#027a48", cursor: "pointer" }}
                        />
                        100%
                      </span>
                    </h4>
                  </div>
                  <div className="sub-dash-2">
                    <p>Total Followers</p>
                    <h4>
                      10.05K{" "}
                      <span>
                        <Icon
                          icon="formkit:arrowup"
                          width="12"
                          height="12"
                          style={{ color: "#027a48", cursor: "pointer" }}
                        />
                        100%
                      </span>
                    </h4>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    marginTop: "30px",
                  }}
                  className="sub-dash-3-1"
                >
                   <div className="month-listen-head">
              <h4>Monthly Listeners</h4>
              <img src="/images/chart-icon.png" alt="" />
            </div>
                  <div style={{ height: "290px" }}>
                    <MonthlyListenersChart />
                  </div>
                </div>
                <div className="dash-3">
                  <div className="sub-dash-3-1">
                  <div className="month-listen-head">
              <h4>Monthly Listeners</h4>
              <img src="/images/chart-icon.png" alt="" />
            </div>
                    <div style={{ height: "290px" }}>
                      <MonthlyListenersChart />
                    </div>
                  </div>
                  <div className="sub-dash-3-2">
                       <div className="top-listen-head">
                                 <h4>Top Listeners</h4>
                                 <Icon
                                   icon="entypo:dots-three-horizontal"
                                   width="16"
                                   height="16"
                                   style={{ color: "#818893", cursor: "pointer" }}
                                 />
                               </div>
                    <div>
                      <TopListenersChart />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {activeLink === "users" && (
            <>
              <div className="all-user-inner-div">
                {/* Filter Buttons */}
                <div className="filter-btn">
                  <button
                    className={`filter-btn-button ${
                      filter === "Followers" ? "active" : ""
                    }`}
                    onClick={() => setFilter("Followers")}
                  >
                    Followers
                  </button>
                  <button
                    className={`filter-btn-button ${
                      filter === "Blocked" ? "active" : ""
                    }`}
                    onClick={() => setFilter("Blocked")}
                  >
                    Blocked user
                  </button>
                </div>

                {/* User Table */}
                <div className="new-table-scroll">
                  <div className="table-div-con">
                    <table
                      border="1"
                      cellPadding="10"
                      cellSpacing="0"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredUsers.map((user) => (
                          <tr key={user.id}>
                            <td
                              style={{
                                color: "#101828",
                              }}
                            >
                              <div className="username-pic">
                                <img src={user.pic} alt="" />
                                {user.name}
                              </div>
                            </td>
                            <td
                              style={{
                                color: "#475467",
                              }}
                            >
                              {user.email}
                            </td>
                            <td
                              style={{
                                color: "#475467",
                                fontWeight: "600",
                              }}
                            >
                              {" "}
                              {user.status === "Blocked" ? "Unblock" : "Block"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </StatsRap>
  );
};

export default Stats;
